import { isNonEmptyString } from './utils'

export default {
  authenticated(state) {
    return state.roles.length >= 0 &&
           isNonEmptyString(state.accessToken) &&
           isNonEmptyString(state.email)
  },
  getUserData(state) {
    return {
      name: state.name,
      email: state.email
    }
  }
}
